(function () {
  var VERSION = "r202";
  var root = document.documentElement;
  var launch = document.getElementById("llb-app-launch");
  var intentAt = Number(window.__llbLaunchIntentAt || 0);
  var hardDeadline = Number(window.__llbLaunchHardDeadline || 0);
  var keydownHandler = null;

  function clearEmergencyTimer() {
    if (typeof window.__llbClearLaunchHeadGuards === "function") {
      window.__llbClearLaunchHeadGuards();
      return;
    }
    if (!window.__llbLaunchEmergencyTimer) return;
    window.clearTimeout(window.__llbLaunchEmergencyTimer);
    window.__llbLaunchEmergencyTimer = null;
  }

  function failOpen(reason) {
    clearEmergencyTimer();
    if (keydownHandler) document.removeEventListener("keydown", keydownHandler, true);
    root.classList.remove("llb-launch-active");
    root.classList.remove("llb-launch-playing");
    root.classList.add("llb-launch-done");
    if (launch) {
      launch.setAttribute("hidden", "");
      launch.style.display = "none";
    }
    emitLaunchEnd(reason || "fail-open", 0);
  }

  function emitLaunchEnd(reason, duration) {
    if (typeof window.__llbEmitLaunchEnd === "function") {
      window.__llbEmitLaunchEnd(reason);
      return;
    }
    if (window.__llbLaunchEndEmitted) return;
    window.__llbLaunchEndEmitted = true;
    try {
      document.dispatchEvent(new CustomEvent("llb:launch:end", {
        detail: { version: VERSION, reason: reason || "complete", duration: duration || 0 }
      }));
    } catch (error) {}
  }

  if (!launch || !root.classList.contains("llb-launch-active")) {
    root.classList.remove("llb-launch-playing");
    if (launch) launch.remove();
    return;
  }

  try {
    var reducedQuery = window.matchMedia("(prefers-reduced-motion: reduce)");
    var now = performance.now();
    if (!intentAt) intentAt = now;
    if (!hardDeadline) hardDeadline = intentAt + 3000;
    var elapsed = Math.max(0, now - intentAt);
    var visualDuration = reducedQuery.matches ? 1140 : 1800;
    if (elapsed >= visualDuration || now >= hardDeadline) {
      failOpen(reducedQuery.matches ? "late-reduced-init" : "late-init");
      return;
    }

    root.classList.add("llb-launch-playing");
    var startedAt = intentAt;
    var completed = false;
    var watchdog = window.setTimeout(function () {
      finish("watchdog");
    }, Math.max(0, hardDeadline - performance.now()));

    function emit(name, detail) {
      try {
        document.dispatchEvent(new CustomEvent(name, { detail: detail }));
      } catch (error) {}
    }

    function finish(reason) {
      if (completed) return;
      completed = true;
      window.clearTimeout(watchdog);
      clearEmergencyTimer();
      if (keydownHandler) document.removeEventListener("keydown", keydownHandler, true);
      root.classList.remove("llb-launch-active");
      root.classList.remove("llb-launch-playing");
      root.classList.add("llb-launch-done");
      launch.setAttribute("hidden", "");
      launch.style.display = "none";
      emitLaunchEnd(reason || "complete", Math.round(performance.now() - startedAt));
      window.requestAnimationFrame(function () {
        if (launch.parentNode) launch.parentNode.removeChild(launch);
      });
    }

    launch.dataset.llbLaunchStarted = String(Math.round(startedAt));
    if (!window.__llbLaunchStartEmitted) {
      window.__llbLaunchStartEmitted = true;
      emit("llb:launch:start", {
        version: VERSION,
        reducedMotion: reducedQuery.matches
      });
    }

    launch.addEventListener("animationend", function (event) {
      if (event.target !== launch) return;
      if (event.animationName === "llbLaunchOverlayExit" || event.animationName === "llbLaunchReducedExit") {
        finish("animation-complete");
      }
    });

    keydownHandler = function (event) {
      if (event.key === "Escape" || event.key === "Tab") finish("keyboard-skip");
    };
    document.addEventListener("keydown", keydownHandler, true);

    document.addEventListener("visibilitychange", function () {
      if (document.visibilityState === "hidden") finish("page-hidden");
    }, { once: true });

    window.addEventListener("pagehide", function () {
      finish("pagehide");
    }, { once: true });

    window.addEventListener("pageshow", function (event) {
      if (event.persisted) finish("bfcache");
    }, { once: true });

    if (typeof reducedQuery.addEventListener === "function") {
      reducedQuery.addEventListener("change", function (event) {
        if (event.matches) finish("reduced-motion-change");
      }, { once: true });
    }

    window.requestAnimationFrame(function () {
      var catchup = Math.max(0, performance.now() - intentAt);
      launch.getAnimations({ subtree: true }).forEach(function (animation) {
        try {
          animation.currentTime = catchup;
        } catch (error) {}
      });
    });
  } catch (error) {
    failOpen("initialization-error");
  }
})();
